import { browserHistory } from 'react-router'
import 'whatwg-fetch'

// import auth from './auth'

const checkStatus = (comb) => {
  const { res } = comb;
  if (res && (res.status < 200 || res.status >= 300)) {
    const error = new Error(res.statusText);
    Object.keys(comb).forEach((key) => {
      error[key] = comb[key];
    });
    throw error;
  }

  return comb;
};

export default (options = {}) => {
  let url = options.url;

  // const tokenProvided = () => {
  //   return url === 'login' || auth.getToken();
  // }

  delete options.url;
  // if (auth.isExpired() || !tokenProvided()) {
  //   auth.logout()
  //   browserHistory.push({pathname: '/login', query: {expired: true}})
  //   throw new Error('Session expired. Please log in again.');
  // }
  const opts = Object.assign(options, {
    headers: new Headers(Object.assign({
      'Content-Type': 'application/json',
      'Accept': 'application/x.mrtn.v1+json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    }, options.headers)),
    body: JSON.stringify(options.body)
  })

  if (options.params) {
    url = `${url}?${toQueryString(options.params)}`
  }

  delete options.params
  let bod;
  return fetch(url, opts)
    .catch(handleErrors)
    .then(response => {
      return response.json()
        .catch(() => response.text())
        .catch(() => null)
        .then(res => {
          bod = res;
          return response;
        })
        .then(res => checkStatus({ body: bod, res }))
        .catch(handleErrors);
    })
}

function handleErrors(response) {
  const { res, body } = response;
  if (!response.ok) {
    if (res && res.status === 401 && body.error === "token_expired") {
      localStorage.removeItem('token');
      browserHistory.push('/login');
    }
    throw response;
  }
  return response;
}

export function toQueryString (obj) {
  let parts = []
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      parts.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]))
    }
  }
  return parts.join('&')
}



// WEBPACK FOOTER //
// ./src/services/request.js